import { DatePickerProps } from "@newsela/angelou";
export type DateValue = Exclude<DatePickerProps["value"], undefined>;

export const formatDateValueToStringWithoutTime = (dateValue: DateValue) => {
  return dateValue.toString().split("T")[0] ?? "";
};
